"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kansaReportReducer = exports.kansaReportActions = exports.TYPES = exports.PERMISSION_KEY = exports.CONTENTS = void 0;
var _CodeConsts = require("01_core/constants/CodeConsts");
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
const _excluded = ["hikansabumon"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'Report';

// アクションタイプ
const TYPES = exports.TYPES = {
  SET_IN_PARENT_COMPANY: PREFIX + 'SetInParentCompany',
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  CHANGE_SCROLL_TOP: PREFIX + 'ChangeScrollTop',
  CHANGE_PAGE: PREFIX + 'ChangePage',
  APPLY_SHARE_CONDITION: PREFIX + 'ApplyShareCondtion',
  INIT_CONDITION_KANSA_TGT_NENDO: PREFIX + 'InitializeconditionKansaTgtNendo',
  INIT_CONDITION_HIKANSABUMON: PREFIX + 'InitializeConditionHikansabumon',
  CHANGE_SEARCH_CONDITION: PREFIX + 'ChangeSearchCondition',
  FIX_CONDITIONS: PREFIX + 'FixCondtions',
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  SET_RP_ENTRIES: PREFIX + 'SetRpEntries',
  SET_RP_ENTRY: PREFIX + 'SetRpEntry',
  SET_EV_ENTRIES: PREFIX + 'SetEvEntries',
  SET_EV_ENTRY: PREFIX + 'SetEvEntry',
  SET_DETAIL: PREFIX + 'SetDetail',
  SHOW_SUBWINDOW: PREFIX + 'ShowSubwindow',
  SET_CREATION_REGISTER: PREFIX + 'SetCreationRegister',
  RESET_CREATION_REGISTER: PREFIX + 'ResetCreationRegister',
  SET_EVALUATION_REGISTER: PREFIX + 'SetEvaluationRegister',
  RESET_EVALUATION_REGISTER: PREFIX + 'ResetEvaluationRegister',
  GO_MAIN: PREFIX + 'GoMain',
  GO_REGISTER: PREFIX + 'GoRegister',
  GO_REFER: PREFIX + 'GoRefer',
  GO_EV_REGISTER: PREFIX + 'GoEvRegister',
  GO_EV_REFER: PREFIX + 'GoEvRefer',
  SET_SUBWINDOW: PREFIX + 'SetSubwindow',
  CLEAR_RP_ENTRIES: PREFIX + 'ClearRpEntries',
  CLEAR_EV_ENTRIES: PREFIX + 'ClearEvEntries',
  CLEAR_DETAIL: PREFIX + 'ClearDetail',
  CLEAR: PREFIX + 'Clear'
};

// 表示コンテンツ
const CONTENTS = exports.CONTENTS = {
  MENU: 'menu',
  HOME: 'home',
  SEARCH: 'main',
  REGISTER: 'register',
  REFER: 'refer',
  EV_REGISTER: 'evRegister',
  EV_REFER: 'evRefer',
  DETAIL: 'detail'
};
const INIT_CONDITION = Object.freeze({
  kansaTgtNendo: '',
  kansaThemeNm: '',
  hikansabumonKaishaCd: '',
  hikansabumonSoshikiCd: '',
  hikansabumon: '',
  creationStsCd: _CodeConsts.CODE.KANSA_RP_CRESTS.CODE_0,
  evaluationStsCd: _CodeConsts.CODE.KANSA_RP_EVSTS.CODE_0
});
const INIT_CREATION = Object.freeze({
  entries: {
    kansabumonComment: ''
  },
  entryStsCd: '',
  subwindow: null,
  ready: false
});
const INIT_EVALUATION = Object.freeze({
  entries: {
    kinyuDate: '',
    kinyushaNm: '',
    comment: ''
  },
  entryStsCd: '',
  subwindow: null,
  ready: false
});
const INIT_DETAIL = Object.freeze({
  entries: {
    kansaTgtNendoNm: null,
    hakkenjikoBunrui: '',
    hikansabumon: '',
    kansaTaishoJigyoList: []
  },
  ready: false
});
const INIT_STATE = {
  containerInfo: {
    dispContent: CONTENTS.SEARCH,
    previousContent: CONTENTS.MENU,
    entranceContent: CONTENTS.MENU,
    subContent: '',
    referCondition: '',
    detailCondition: ''
  },
  searchConditions: _objectSpread({}, INIT_CONDITION),
  fixedConditions: _objectSpread({}, INIT_CONDITION),
  searchResult: [],
  targetReport: {},
  creation: _objectSpread({}, INIT_CREATION),
  evaluation: _objectSpread({}, INIT_EVALUATION),
  main: {
    paging: {
      viewNum: 50,
      currentPage: 0
    },
    scrollTop: {
      index: 0,
      scrollY: 0,
      noSticky: false
    }
  },
  detail: _objectSpread({}, INIT_DETAIL),
  search: false,
  temporarilySaved: false,
  kansaTgtNendoInitialized: false,
  hikansabumonInitialized: false,
  inParentCompany: false
};

// 利用許可属性
const PERMISSION_KEY = exports.PERMISSION_KEY = {
  KAISHA_SOSHIKI_SELECT_ALL: 'kaishasoshiki:select:all_kaisha'
};
const kansaReportActions = exports.kansaReportActions = (0, _reduxActions.createActions)({
  [TYPES.APPLY_SHARE_CONDITION]: function () {
    return {
      shareCondition: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SEARCH_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      searchResult: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      viewNum: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_PAGE]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      currentPage: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      scrollTop: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.INIT_CONDITION_HIKANSABUMON]: function () {
    return {
      kaishaCd: arguments.length <= 0 ? undefined : arguments[0],
      hikansabumon: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.INIT_CONDITION_KANSA_TGT_NENDO]: function () {
    return {
      kansaTgtNendo: arguments.length <= 0 ? undefined : arguments[0],
      kansaThemeNm: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_IN_PARENT_COMPANY]: function () {
    return {
      inParentCompany: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_MAIN]: function () {
    return {
      previousContent: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_REGISTER]: function () {
    return {
      targetReport: arguments.length <= 0 ? undefined : arguments[0],
      previousContent: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.GO_REFER]: function () {
    return {
      targetReport: arguments.length <= 0 ? undefined : arguments[0],
      previousContent: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.GO_EV_REGISTER]: function () {
    return {
      targetReport: arguments.length <= 0 ? undefined : arguments[0],
      previousContent: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.GO_EV_REFER]: function () {
    return {
      targetReport: arguments.length <= 0 ? undefined : arguments[0],
      previousContent: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SHOW_SUBWINDOW]: function () {
    return {
      content: arguments.length <= 0 ? undefined : arguments[0],
      keyReferCondition: arguments.length <= 1 ? undefined : arguments[1],
      keyDetailCondition: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  [TYPES.SET_RP_ENTRIES]: function () {
    return {
      entries: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_RP_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_CREATION_REGISTER]: function () {
    return {
      value: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_EV_ENTRIES]: function () {
    return {
      entries: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_EV_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_EVALUATION_REGISTER]: function () {
    return {
      value: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_DETAIL]: function () {
    return {
      entries: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_SUBWINDOW]: function () {
    return {
      value: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.RESET_CREATION_REGISTER, TYPES.RESET_EVALUATION_REGISTER, TYPES.FIX_CONDITIONS, TYPES.CLEAR_RP_ENTRIES, TYPES.CLEAR_EV_ENTRIES, TYPES.CLEAR_DETAIL, TYPES.CLEAR);
const kansaReportReducer = exports.kansaReportReducer = (0, _reduxActions.handleActions)({
  [TYPES.APPLY_SHARE_CONDITION]: (state, action) => {
    const _action$payload$share = action.payload.shareCondition,
      {
        hikansabumon
      } = _action$payload$share,
      rest = _objectWithoutProperties(_action$payload$share, _excluded);
    return _objectSpread(_objectSpread({}, state), {}, {
      searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), rest),
      hikansabumon
    });
  },
  [TYPES.CHANGE_SEARCH_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  [TYPES.FIX_CONDITIONS]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    fixedConditions: _objectSpread({}, state.searchConditions)
  }),
  [TYPES.SET_SEARCH_RESULT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchResult: action.payload.searchResult,
    search: false
  }),
  [TYPES.CHANGE_PAGE]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      [action.payload.key]: _objectSpread(_objectSpread({}, state[action.payload.key]), {}, {
        paging: _objectSpread(_objectSpread({}, state[action.payload.key].paging), {}, {
          currentPage: action.payload.currentPage
        })
      })
    });
  },
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      [action.payload.key]: _objectSpread(_objectSpread({}, state[action.payload.key]), {}, {
        paging: _objectSpread(_objectSpread({}, state[action.payload.key].paging), {}, {
          currentPage: 0,
          viewNum: action.payload.viewNum
        })
      })
    });
  },
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      [action.payload.key]: _objectSpread(_objectSpread({}, state[action.payload.key]), {}, {
        scrollTop: action.payload.scrollTop
      })
    });
  },
  [TYPES.INIT_CONDITION_KANSA_TGT_NENDO]: (state, action) => {
    if (state.kansaTgtNendoInitialized) {
      return _objectSpread({}, state);
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
        kansaTgtNendo: action.payload.kansaTgtNendo,
        kansaThemeNm: action.payload.kansaThemeNm
      }),
      kansaTgtNendoInitialized: true
    });
  },
  [TYPES.INIT_CONDITION_HIKANSABUMON]: (state, action) => {
    if (state.hikansabumonInitialized) {
      return _objectSpread({}, state);
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
        hikansabumonKaishaCd: action.payload.kaishaCd,
        hikansabumon: action.payload.hikansabumon
      }),
      hikansabumonInitialized: true
    });
  },
  [TYPES.GO_MAIN]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      search: true,
      containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
        dispContent: CONTENTS.SEARCH,
        previousContent: action.payload.previousContent
      })
    });
  },
  [TYPES.GO_REGISTER]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      targetReport: action.payload.targetReport,
      containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
        dispContent: CONTENTS.REGISTER,
        previousContent: action.payload.previousContent
      })
    });
  },
  [TYPES.GO_REFER]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      targetReport: action.payload.targetReport,
      containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
        dispContent: CONTENTS.REFER,
        previousContent: action.payload.previousContent
      })
    });
  },
  [TYPES.GO_EV_REGISTER]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      targetReport: action.payload.targetReport,
      containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
        dispContent: CONTENTS.EV_REGISTER,
        previousContent: action.payload.previousContent
      })
    });
  },
  [TYPES.GO_EV_REFER]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      targetReport: action.payload.targetReport,
      containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
        dispContent: CONTENTS.EV_REFER,
        previousContent: action.payload.previousContent
      })
    });
  },
  [TYPES.SHOW_SUBWINDOW]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
        subContent: action.payload.content,
        referCondition: action.payload.keyReferCondition,
        detailCondition: action.payload.keyDetailCondition
      })
    });
  },
  [TYPES.SET_RP_ENTRIES]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    creation: _objectSpread(_objectSpread({}, state.creation), {}, {
      ready: true,
      entries: action.payload.entries
    })
  }),
  [TYPES.SET_RP_ENTRY]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    creation: _objectSpread(_objectSpread({}, state.creation), {}, {
      entries: _objectSpread(_objectSpread({}, state.creation.entries), {}, {
        [action.payload.key]: action.payload.value
      })
    })
  }),
  [TYPES.SET_CREATION_REGISTER]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    creation: _objectSpread(_objectSpread({}, state.creation), {}, {
      entryStsCd: action.payload.value
    })
  }),
  [TYPES.RESET_CREATION_REGISTER]: state => _objectSpread(_objectSpread({}, state), {}, {
    creation: _objectSpread(_objectSpread({}, state.creation), {}, {
      entryStsCd: ''
    })
  }),
  [TYPES.SET_EV_ENTRIES]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    evaluation: _objectSpread(_objectSpread({}, state.evaluation), {}, {
      ready: true,
      entries: action.payload.entries
    })
  }),
  [TYPES.SET_EV_ENTRY]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    evaluation: _objectSpread(_objectSpread({}, state.evaluation), {}, {
      entries: _objectSpread(_objectSpread({}, state.evaluation.entries), {}, {
        [action.payload.key]: action.payload.value
      })
    })
  }),
  [TYPES.SET_EVALUATION_REGISTER]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    evaluation: _objectSpread(_objectSpread({}, state.evaluation), {}, {
      entryStsCd: action.payload.value
    })
  }),
  [TYPES.RESET_EVALUATION_REGISTER]: state => _objectSpread(_objectSpread({}, state), {}, {
    evaluation: _objectSpread(_objectSpread({}, state.evaluation), {}, {
      entryStsCd: ''
    })
  }),
  [TYPES.SET_DETAIL]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    detail: _objectSpread(_objectSpread({}, state.detail), {}, {
      entries: action.payload.entries,
      ready: true
    })
  }),
  [TYPES.SET_SUBWINDOW]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    creation: _objectSpread(_objectSpread({}, state.creation), {}, {
      subwindow: action.payload.value
    })
  }),
  [TYPES.SET_IN_PARENT_COMPANY]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    inParentCompany: action.payload.inParentCompany
  }),
  [TYPES.CLEAR_RP_ENTRIES]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    creation: _objectSpread(_objectSpread({}, state.creation), {}, {
      ready: false,
      entries: INIT_CREATION.entries
    })
  }),
  [TYPES.CLEAR_EV_ENTRIES]: state => _objectSpread(_objectSpread({}, state), {}, {
    evaluation: _objectSpread(_objectSpread({}, state.evaluation), {}, {
      ready: false,
      entries: INIT_EVALUATION.entries
    })
  }),
  [TYPES.CLEAR_DETAIL]: state => _objectSpread(_objectSpread({}, state), {}, {
    detail: _objectSpread({}, INIT_DETAIL)
  }),
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE)
}, INIT_STATE);